import { __awaiter, __generator } from "tslib";
import { eventIsTrusted, getEmail, getHashOrNull } from '../../utils';
import { logger } from '../../../logger';
import { version } from '../../constants';
/**
 * handleMessage processes form submissions from iframes, identifying and tracking the user's actions.
 */
var handleMessage = function (analytics, data, shouldHash) { return __awaiter(void 0, void 0, void 0, function () {
    var fields, formName, email, id;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                fields = data.fields, formName = data.formName;
                email = getEmail(fields);
                if (!email) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, getHashOrNull(shouldHash, email)];
            case 1:
                id = _a.sent();
                return [4 /*yield*/, analytics.identify(id, { email: email })];
            case 2:
                _a.sent();
                logger.debug("IFramePlugin: Form with the name '".concat(formName, "' was submitted"));
                logger.debug("IFramePlugin: Identified user with email '".concat(email, "'"));
                return [4 /*yield*/, analytics.track(formName, { version: version })];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export default (function (analytics, options) {
    window.addEventListener('message', function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var data, shouldHash;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    data = event.data;
                    if (!(eventIsTrusted(event) && data && data.type === 'dreamdata-message')) return [3 /*break*/, 2];
                    shouldHash = options.shouldHash;
                    return [4 /*yield*/, handleMessage(analytics, data, shouldHash || false)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); });
});
//# sourceMappingURL=index.js.map